import { ShieldCheck } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "입학 지원 자격은 어떻게 되나요?",
  answer: "신입학의 경우 고등학교 졸업(예정)자 또는 법령에 의하여 이와 동등 이상의 학력이 있다고 인정되는 분이라면 누구나 지원 가능합니다. 편입학은 전문대학 졸업자 또는 4년제 대학교에서 일정 학점 이상을 이수한 경우 지원하실 수 있습니다."
}, {
  question: "수능 성적이 없어도 지원 가능한가요?",
  answer: "네, 가능합니다. 건양사이버대학교는 수능 성적이나 고교 내신 성적을 반영하지 않습니다. 대신 자기소개서와 학업적성검사를 통해 선발하므로 배움에 대한 열정이 있다면 누구나 도전하실 수 있습니다."
}, {
  question: "직장인도 학업 병행이 가능한가요?",
  answer: "네, 전체 재학생의 상당수가 직장인입니다. 100% 온라인 강의와 시험으로 진행되기 때문에 시공간의 제약 없이 PC나 모바일로 언제 어디서든 학습이 가능하여 일과 학업을 충분히 병행하실 수 있습니다."
}, {
  question: "국가장학금 혜택을 받을 수 있나요?",
  answer: "본교는 교육부 인가 정규 4년제 대학교로 국가장학금 신청이 가능합니다. 소득 구간에 따라 등록금 전액 또는 일부를 지원받을 수 있으며, 이외에도 다양한 교내 장학 혜택을 운영하고 있습니다."
}];
export default function Faq() {
  return <section data-section-id="238953" id="자주-묻는-질문" className="bg-background text-foreground py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/5 rounded-lg blur-3xl pointer-events-none" />

      <div className="max-w-3xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center p-3 bg-accent rounded-2xl mb-6 border border-border">
            <ShieldCheck className="w-8 h-8 text-primary" />
          </div>
          <h2 className="text-4xl md:text-5xl font-default font-bold text-foreground mb-4 tracking-tight">
            자주 묻는 질문
          </h2>
          <p className="text-muted-foreground font-default text-lg max-w-xl mx-auto">
            건양사이버대학교 입학에 대해 자주 묻는 질문을 정리했습니다.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border rounded-md bg-card shadow-sm overflow-hidden transition-all duration-300 data-[state=open]:border-primary/40 data-[state=open]:bg-card data-[state=open]:shadow-md">
              <AccordionTrigger className="px-6 py-5 text-base md:text-lg lg:text-lg font-default font-semibold hover:no-underline text-foreground data-[state=open]:text-primary transition-colors text-left">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-6 text-sm md:text-base lg:text-base text-muted-foreground font-default leading-relaxed">
                <div className="pt-4 border-t border-border/50">
                  {faq.answer}
                </div>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}